// import React from "react";
// import Navbar from "./Navbar";
// import Footer from "./Footer";
// import FadeInOnScroll from "./FadeInOnScroll";
// import SlideInOnScroll from "./SlideInOnScroll";
// import { motion } from "framer-motion";

// export default function OurReach() {
//   // 5 个点的配置：图片 + 位置 + 飞入方向
//   const markers = [
//     {
//       src: "/map1.png",
//       alt: "Xinjiang China 2026",
//       style: { top: "38%", left: "36%" }, // 左上
//       fromX: -60,
//       fromY: -20,
//     },
//     {
//       src: "/map2.png",
//       alt: "Xiong'an China 2026",
//       style: { top: "38%", right: "36%" }, // 右上
//       fromX: 60,
//       fromY: -20,
//     },
//     {
//       src: "/map3.png",
//       alt: "Singapore HQ",
//       style: { top: "37%", left: "36%" }, // 左中偏下
//       fromX: -60,
//       fromY: 10,
//     },
//     {
//       src: "/map4.png",
//       alt: "Indonesia",
//       style: { bottom: "35%", left: "37%" }, // 底部中间偏左
//       fromX: 0,
//       fromY: 40,
//     },
//     {
//       src: "/map5.png",
//       alt: "Malaysia",
//       style: { top: "38%", right: "36%" }, // 右中偏下
//       fromX: 60,
//       fromY: 10,
//     },
//   ];

//   return (
//     <>
//       <section className="bg-gradient-to-br from-purple-50 via-purple-100 to-purple-50 py-20 md:py-24 px-6 text-[#1e0b44] overflow-x-hidden">
//         <div className="max-w-7xl mx-auto">
//           {/* ===== 顶部标题 ===== */}
//           <div className="text-center mb-16">
//             <FadeInOnScroll>
//               <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-[#6a2dd9] to-[#9a8dfc] bg-clip-text text-transparent mb-2">
//                 OUR GLOBAL REACH
//               </h2>
//               <p className="text-xs sm:text-sm tracking-[0.25em] text-[#5e4ca8] font-semibold uppercase">
//                 WITH LOCAL PROXIMITY
//               </p>
//             </FadeInOnScroll>
//           </div>

//           {/* ===== 中间：地图 + 飞入标记 ===== */}
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-16">
//             {/* 左侧地图区域（底图不动） */}
//             <div className="flex justify-center">
//               <div className="relative w-full max-w-xl aspect-[4/3] overflow-hidden">
//                 {/* 底图：不动 */}
//                 <img
//                   src="/asia-map-purple-new.png"
//                   alt="Asia Data Centers"
//                   className="w-full h-full object-contain opacity-95 drop-shadow-[0_10px_25px_rgba(106,45,217,0.35)]"
//                 />

//                 {/* 5 个点：依次飞进来 */}
//                 {markers.map((m, index) => (
//                   <motion.img
//                     key={m.alt}
//                     src={m.src}
//                     alt={m.alt}
//                     className="absolute w-32 md:w-40"
//                     style={m.style}
//                     initial={{
//                       opacity: 0,
//                       x: m.fromX,
//                       y: m.fromY,
//                       scale: 0.9,
//                     }}
//                     whileInView={{
//                       opacity: 1,
//                       x: 0,
//                       y: 0,
//                       scale: 3.5,
//                     }}
//                     viewport={{ once: true, margin: "-100px" }}
//                     transition={{
//                       duration: 0.6,
//                       ease: "easeOut",
//                       delay: 0.3 + index * 0.25, // 一个一个接着飞
//                     }}
//                   />
//                 ))}
//               </div>
//             </div>

//             {/* 右侧说明文字：从右侧滑入 */}
//             <SlideInOnScroll from="right" delay={0.2}>
//               <div className="space-y-5 text-lg font-semibold text-purple-900 tracking-wide text-center max-w-xl mx-auto">
//                 <p>
//                   AI Nova achieved a major milestone with the deployment of our
//                   flagship AI infrastructure in Indonesia, one of the most
//                   ambitious GPU cluster projects in the region.
//                 </p>
//                 <p>
//                   AI NOVA is expanding in Southeast Asia, creating a connected
//                   ASEAN AI fabric that links compute, data, and opportunity
//                   across borders, while respecting sovereignty.
//                 </p>
//               </div>
//             </SlideInOnScroll>
//           </div>

//           {/* ===== 底部两块卡片 ===== */}
//           <div className="space-y-8 max-w-3xl mx-auto">
//             {/* 第一张卡片：从左侧滑入 */}
//             <SlideInOnScroll from="left" delay={0.1}>
//               <div className="bg-white rounded-[1.5rem] px-6 sm:px-10 py-6 shadow-[5px_6px_0_rgba(15,23,42,0.45)]">
//                 <p className="text-[0.98rem] leading-relaxed text-[#2a0f4c]/90">
//                   <strong>AI NOVA</strong> state-of-the-art data{" "}
//                   <span className="underline decoration-[#a020f0]/70">
//                     centers
//                   </span>{" "}
//                   are strategically located in powerhouse cities across various
//                   countries to deliver unmatched compute power, speed,
//                   resilience and access to targeted markets.
//                 </p>
//               </div>
//             </SlideInOnScroll>

//             {/* 第二张卡片：从右侧滑入（或 bottom 也行，看你喜好） */}
//             <SlideInOnScroll from="right" delay={0.2}>
//               <div className="bg-white rounded-[1.5rem] px-6 sm:px-10 py-6 shadow-[5px_6px_0_rgba(15,23,42,0.45)]">
//                 <p className="text-[0.98rem] leading-relaxed text-[#2a0f4c]/90">
//                   <strong>AI NOVA</strong> state-of-the-art data{" "}
//                   <span className="underline decoration-[#a020f0]/70">
//                     centers
//                   </span>{" "}
//                   comprise custom-configured high-performance compute nodes,
//                   resilient storage, ultra-low latency networking and
//                   GPU-accelerated servers.
//                 </p>
//               </div>
//             </SlideInOnScroll>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// }
import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FadeInOnScroll from "./FadeInOnScroll";
import SlideInOnScroll from "./SlideInOnScroll";
import { motion } from "framer-motion";

export default function OurReach() {
  // 5 个点的配置：图片 + 位置 + 飞入方向
  const markers = [
    {
      src: "/map1 (1).png",
      alt: "Xinjiang China 2026",
      style: { top: "0%", left: "-20%" }, // 左上
      fromX: 0,
      fromY: 0,
    },
    {
      src: "/map2 (1).png",
      alt: "Xiong'an China 2026",
      style: { top: "38%", right: "36%" }, // 右上
      fromX: 60,
      fromY: -20,
    },
    {
      src: "/map3 (1).png",
      alt: "Singapore HQ",
      style: { top: "37%", left: "36%" }, // 左中偏下
      fromX: -60,
      fromY: 10,
    },
    {
      src: "/map4 (1).png",
      alt: "Indonesia",
      style: { bottom: "35%", left: "37%" }, // 底部中间偏左
      fromX: 0,
      fromY: 40,
    },
    {
      src: "/map5 (1).png",
      alt: "Malaysia",
      style: { top: "38%", right: "36%" }, // 右中偏下
      fromX: 60,
      fromY: 10,
    },
  ];

  return (
    <>
      <section className="bg-gradient-to-br from-purple-50 via-purple-100 to-purple-50 py-20 md:py-24 px-6 text-[#1e0b44] overflow-x-hidden">
        <div className="max-w-7xl mx-auto">
          {/* ===== 顶部标题 ===== */}
          <div className="text-center mb-10">
            <FadeInOnScroll>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#252666] mb-2">
                OUR GLOBAL REACH
              </h2>
              <p className="text-xs sm:text-sm tracking-[0.25em] text-[#5e4ca8] font-semibold uppercase">
                WITH LOCAL PROXIMITY
              </p>
            </FadeInOnScroll>
          </div>

          {/* ===== 顶部说明文字（移动到这里，居中整行） ===== */}
          <div className="mb-16">
            <SlideInOnScroll from="right" delay={0.2}>
              <div className="space-y-5 text-lg font-semibold text-[#6b5fa9] tracking-wide text-center max-w-3xl mx-auto">
                <p>
                  AI Nova achieved a major milestone with the deployment of our
                  flagship AI infrastructure in Indonesia, one of the most
                  ambitious GPU cluster projects in the region.
                </p>
                <p>
                  AI NOVA is expanding in Southeast Asia, creating a connected
                  ASEAN AI fabric that links compute, data, and opportunity
                  across borders, while respecting sovereignty.
                </p>
              </div>
            </SlideInOnScroll>
          </div>

          {/* ===== 下方：左地图 / 右两张卡片（按截图） ===== */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            {/* 左侧地图区域（底图不动） */}
            <div className="flex justify-center">
              <div className="relative w-full max-w-xl aspect-[4/3] overflow-hidden">
                {/* 底图：不动 */}
                <img
                  src="/asia-map-purple-new.png"
                  alt="Asia Data Centers"
                  className="w-full h-full object-contain opacity-95 drop-shadow-[0_10px_25px_rgba(106,45,217,0.35)]"
                />

                {/* 5 个点：依次飞进来 */}
                {markers.map((m, index) => (
                  <motion.img
                    key={m.alt}
                    src={m.src}
                    alt={m.alt}
                    className="absolute w-32 md:w-40"
                    style={m.style}
                    initial={{
                      opacity: 0,
                      x: m.fromX,
                      y: m.fromY,
                      scale: 0.9,
                    }}
                    whileInView={{
                      opacity: 1,
                      x: 0,
                      y: 0,
                      scale: 3.5,
                    }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{
                      duration: 0.6,
                      ease: "easeOut",
                      delay: 0.3 + index * 0.25, // 一个一个接着飞
                    }}
                  />
                ))}
              </div>
            </div>

            {/* 右侧两张卡片（保持原样式/动画，只挪位置） */}
            <div className="space-y-8 max-w-3xl mx-auto w-full">
              <SlideInOnScroll from="left" delay={0.1}>
                <div className="bg-white rounded-[1.5rem] px-6 sm:px-10 py-6 shadow-[5px_6px_0_rgba(15,23,42,0.45)]">
                  <p className="text-[0.98rem] leading-relaxed text-[#2a0f4c]/90">
                    <strong>AI NOVA</strong> state-of-the-art data centers are
                    strategically located in powerhouse cities across various
                    countries to deliver unmatched compute power, speed,
                    resilience and access to targeted markets.
                  </p>
                </div>
              </SlideInOnScroll>

              <SlideInOnScroll from="right" delay={0.2}>
                <div className="bg-white rounded-[1.5rem] px-6 sm:px-10 py-6 shadow-[5px_6px_0_rgba(15,23,42,0.45)]">
                  <p className="text-[0.98rem] leading-relaxed text-[#2a0f4c]/90">
                    <strong>AI NOVA</strong> state-of-the-art data centers
                    comprise custom-configured high-performance compute nodes,
                    resilient storage, ultra-low latency networking and
                    GPU-accelerated servers.
                    {/* <span className="underline decoration-[#a020f0]/70">
                      centers
                    </span>{" "} */}
                  </p>
                </div>
              </SlideInOnScroll>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
